<template>
  <div class="container">
    <div class="btn-wrapper">
      <el-button class="add-new-btn" @click="handleChange(1)">
        <i class="iconfont iconProperty1tianjia"></i> New
      </el-button>
    </div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Number" prop="id" min-width="140"></el-table-column>
        <el-table-column
          label="level"
          prop="name"
          show-overflow-tooltip
          min-width="280"
          style="background:red"
        >
          <template v-slot="{row}">
            <div
              class="table-label"
              :style="{color:row.fontColor,background:row.backgroundColor,padding: '10px',borderRadius: '4px'}"
            >{{ row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="User Count" prop="userCount" min-width="90">
          <template v-slot="{row}">
            <div v-if="Number(row.id) !== 14">{{ row.userCount }}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="Odds Level" prop="oddsLevelId" min-width="90">
          <template v-slot="{row}">
            <div v-if="row.oddsLevelId">{{ formatOddsLevelId(row.oddsLevelId) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Margin Odds Level" prop="marginOddsLevelId" min-width="140">
          <template v-slot="{row}">
            <div v-if="row.marginOddsLevelId">{{ formatOddsLevelId(row.marginOddsLevelId) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Bet Interval Time" prop="minIntervalBetSecond" min-width="120">
          <template v-slot="{row}">
            <div>{{ row.minIntervalBetSecond }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Set Time" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.createTime">{{ formatUtc(row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Level Expired Time" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.expireDay">{{ row.expireDay }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Last Modify Time" min-width="150">
          <template v-slot="{row}">
            <div v-if="row.lastUpdateTime">{{ formatUtc(row.lastUpdateTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Last Modifier" prop="lastUpdateModifier" min-width="150"></el-table-column>
        <el-table-column label="Remark" prop="remark" :show-overflow-tooltip="true" min-width="234"></el-table-column>

        <el-table-column label="Operation" min-width="270" fixed="right">
          <template v-slot="{row}">
            <div>
              <el-button class="table-inner-btn" @click="handleChange(2,row)">Modify</el-button>
              <el-button
                v-if="!(row.id == 14 || row.id == 22)"
                class="table-inner-btn"
                @click="handleChange(3,row)"
              >Delete</el-button>
              <el-button class="table-inner-btn" @click="handleChange(4,row)">History</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <dia ref="dialogDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1">
        <el-form :model="form" label-width="56px">
          <el-form-item label="Label">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Remark">
            <el-input v-model="form.remark" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Level Expired Time">
            <el-input v-model="form.expireDay" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Odds Level">
            <el-select v-model="form.oddsLevelId" :disabled="form.id == 22" filterable placeholder="Select Odds Level">
              <el-option
                v-for="item in oddsLevelList"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Margin Odds Level">
            <el-select v-model="form.marginOddsLevelId" :disabled="form.id == 22" filterable placeholder="Select Margin Odds Level">
              <el-option
                v-for="item in oddsLevelList"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Bet Interval Time">
            <el-select
              v-model="form.minIntervalBetSecond"
              filterable
              placeholder="Select Bet Interval Time"
            >
              <el-option
                v-for="item in betIntervalTime"
                :key="item.id"
                :label="item.name"
                :value="Number(item.id)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="bgColor">
            <el-color-picker v-model="form.backgroundColor"></el-color-picker>
          </el-form-item>
          <el-form-item label="fontColor">
            <el-color-picker v-model="form.fontColor"></el-color-picker>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleViewModify()" v-if="num == 2">Confirm</el-button>
          <el-button class="search-btn" @click="handleViewAdd()" v-if="num == 1">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
      <!-- 删除3 -->
      <div v-if="num == 3">
        <p>
          Level User Count is
          (
          <span class="user-count">{{userCount}}</span> )
        </p>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="Delete()">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()">Cancel</el-button>
        </div>
      </div>
      <!-- history4 -->
      <div v-if="num == 4">
        <!-- <div style="margin-bottom: 10px;">Time：2021-11-12 12:12:31</div> -->
        <el-table
          ref="table"
          :data="itemList"
          height="500"
          v-loading="loadingItem"
          header-row-class-name="table-header-row"
          border
        >
          <template slot="empty">
            <Empty />
          </template>
          <el-table-column label="Time" prop="time" min-width="15%">
            <template v-slot="{ row }">
              <div>{{ formatUtc(row.time) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Level" prop="level" min-width="15%">
            <template v-slot="{ row }">
              <div>{{ formatLevelId(row.levelId) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Odds Level" prop="oddsLevelId" min-width="10%">
            <template v-slot="{ row }">
              <div>{{ formatAlertOddsLevelId(row.oddsLevelId) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Margin Odds Level" prop="marginOddsLevelId" min-width="13%">
            <template v-slot="{ row }">
              <div>{{ formatAlertOddsLevelId(row.marginOddsLevelId) }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Bet Interval Time" prop="minIntervalBetSecond" min-width="12%">
            <template v-slot="{ row }">
              <div>{{ row.minIntervalBetSecond }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Remark" prop="remark" min-width="12%">
            <template v-slot="{ row }">
              <div>{{ row.remark }}</div>
            </template>
          </el-table-column>
          <el-table-column label="Modofier" prop="operator" min-width="17%">
            <template v-slot="{ row }">
              <div>{{ row.operator }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrapper inline-wrapper">
          <el-pagination
            class="inline-right"
            :total="totalAert"
            :current-page="queryAlert.current"
            :page-size="queryAlert.size"
            :page-sizes="[50, 100, 200]"
            @current-change="changeAlertPage"
            @size-change="handleSizeAlertChange"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
        <div class="dialog-footer table-search-part" style="padding-top: 20px;">
          <el-button class="clear-btn" @click="CloseHistory()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import {
  getList,
  getLevelDelete,
  getLevelUpdate,
  getLevelAdd,
  getLevelOperationLog
} from "@/api/level";
import { getLevelList } from "@/api/member";
export default {
  name: "LevelList",
  data() {
    return {
      form: {
        name: "",
        remark: "",
        expireDay: "",
        id: "",
        oddsLevelId: "",
        marginOddsLevelId: "",
        minIntervalBetSecond: 0,
        backgroundColor: "#ffffff",
        fontColor: "#333333"
      },
      loadingItem: false,
      totalAert: 0,
      itemList: [],
      loadingAlert: false,
      id: "",
      num: "",
      list: [],
      total: 0,
      loading: false,
      queryData: {
        current: 1,
        size: 50
      },
      queryAlert: {
        current: 1,
        size: 50,
        levelId: ""
      },
      oddsLevelList: [
        { id: 0, name: "Config" },
        { id: 1, name: "A" },
        { id: 2, name: "B" },
        { id: 3, name: "C" },
        { id: 4, name: "D" },
        { id: 5, name: "E" },
        { id: 6, name: "F" },
        { id: 7, name: "G" }
      ],
      betIntervalTime: [
        { id: 0, name: "0" },
        { id: 5, name: "5" },
        { id: 15, name: "15" },
        { id: 30, name: "30" },
        { id: 60, name: "60" }
      ],
      alertOddsLevelList: [
        { id: 1, name: "A" },
        { id: 2, name: "B" },
        { id: 3, name: "C" },
        { id: 4, name: "D" },
        { id: 5, name: "E" },
        { id: 6, name: "F" },
        { id: 7, name: "G" }
      ],
      levelList: [],
      labelId: "",
      userCount: "",
      tableHeight: window.innerHeight,
      title: "Delete the Label?"
    };
  },
  watch: {
    "form.expireDay": function(newVal, oldVal) {
      if (newVal !== null) {
        // 使用正则表达式检查是否为 1 到 99 之间的正整数
        const validInput = /^[1-9][0-9]?$/.test(newVal);
        // 使用正则表达式检查是否包含英文字符或小数点
        const invalidCharacters = /[a-zA-Z.]/.test(newVal);
        if (!validInput || invalidCharacters) {
          this.form.expireDay = null;
        }
      }
    }
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getList(this.queryData);
        const data = res.data || {};
        this.list = data.records || [];
        this.total = Number(data.total);
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    async getlevelListLog() {
      const res = await getLevelList({});
      let data = res.data || [];
      this.levelList = data;
    },
    async getLevelLog() {
      this.loadingAlert = true;
      try {
        const res = await getLevelOperationLog(this.queryAlert);
        const data = res.data || {};
        this.itemList = data.records || [];
        this.totalAert = Number(data.total);
        this.loadingAlert = false;
      } catch (error) {
        this.itemList = [];
        this.loadingAlert = false;
      }
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatOddsLevelId(val) {
      let name = "";
      this.oddsLevelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    },
    formatLevelId(val) {
      let name = "";
      this.levelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    },
    formatAlertOddsLevelId(val) {
      if (!val || val == 0) {
        return "-";
      }
      let name = "";
      this.alertOddsLevelList.map(item => {
        if (item.id == val) {
          name = item.name;
        }
      });
      return name;
    },
    // 查看详情
    handleViewDetail(data) {
      this.$router.push({
        path: "/risk/detail",
        query: { riskLevelId: data.riskLevelId }
      });
    },
    // 添加
    async handleViewAdd(data) {
      if (this.form.name) {
        const res = await getLevelAdd(this.form);
        if (res.success) {
          this.$message({ message: "add success", type: "success" });
          this.getList();
        }
      } else {
        this.$message({
          message: "The lablename can not be empty",
          type: "warning"
        });
      }
      this.Close();
    },
    handleChange(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "New Level";
        this.form = {
          name: "",
          remark: "",
          id: "",
          expireDay: "",
          oddsLevelId: "",
          marginOddsLevelId: "",
          minIntervalBetSecond: 0,
          backgroundColor: "#ffffff",
          fontColor: "#333333"
        };
        this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
      } else if (num == 2) {
        // 修改
        this.title = "Modify Level";
        this.form.name = data.name;
        this.form.remark = data.remark;
        this.form.expireDay = data.expireDay;
        this.form.oddsLevelId = data.oddsLevelId;
        this.form.marginOddsLevelId = data.marginOddsLevelId;
        this.form.minIntervalBetSecond = data.minIntervalBetSecond;
        this.form.id = data.id;
        this.form.fontColor = data.fontColor;
        this.form.backgroundColor = data.backgroundColor;
        this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
      } else if (num == 4) {
        this.queryAlert.current = 1;
        this.queryAlert.size = 50;
        this.title = "Level History";
        this.queryAlert.levelId = data.id;
        this.$refs["dialogDom"].isShowDia(this.title, true, "1100px");
        this.getLevelLog();
      } else {
        // 删除
        this.title = "Are you sure to delete Level?";
        this.labelId = data.id;
        this.userCount = data.userCount;
        this.$refs["dialogDom"].isShowDia(this.title, true, "500px");
      }
    },
    // 修改
    async handleViewModify(data) {
      if (this.form.name != "") {
        const res = await getLevelUpdate(this.form);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
        }
      } else {
        this.$message({
          message: "The lablename can not be empty",
          type: "warning"
        });
      }
      this.Close();
    },
    // 删除
    async Delete() {
      const res = await getLevelDelete({ ids: [this.labelId] });
      if (res.code == 0) {
        this.$message({ message: "delete success", type: "success" });
        this.getList();
        this.Close();
      }
    },
    // 分页
    changeAlertPage(e) {
      this.queryAlert.current = e;
      this.getLevelLog();
    },
    // 列表显示条目
    handleSizeAlertChange(e) {
      this.queryAlert.size = e;
      this.queryAlert.current = 1;
      this.getLevelLog();
    },
    Close() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "500px");
    },
    CloseHistory() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "1100px");
    }
  },
  mounted() {
    this.getList();
    this.getlevelListLog();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  components: {
    dia,
    Empty
  }
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  margin: 20px 0;
}
.table-label {
  color: #666;
  font-weight: bold;
}
.user-count {
  font-size: 16px;
  font-weight: 600;
  color: #e95353;
}
/deep/.el-form-item__label {
  width: 120px !important;
}
/deep/.el-form-item__content {
  margin-left: 120px !important;
}
</style>
